// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3uFD3","blob":"styles_blob__h2szm","cross":"styles_cross__1EmSE"};